import script from "./NicknameModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NicknameModal.vue?vue&type=script&setup=true&lang=js"

import "./NicknameModal.vue?vue&type=style&index=0&id=7ab7756e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ab7756e"]])

export default __exports__